<template>
  <div class="ui-content dashboard user-section">
    <v-card class="mx-auto normal-card autohg">
      <div class="user-data">
        <v-row>
          <v-col cols="12" sm="12">
            <div class="show-drop-down">
              <div class="label-data">Select Center</div>
              <div class="field-data">
                <multi-select
                  allText="All Centers"
                  :items="centers"
                  label="select center"
                  :onChange="onCenterchange"
                  widthcss="fix-200"
                ></multi-select>
              </div>
            </div>
            <div class="show-drop-down">
              <div class="label-data">Select Batch</div>
              <div class="field-data">
                <multi-select
                  allText="All Batches"
                  :items="batches"
                  label="select batch"
                  :onChange="onBatchSelect"
                  widthcss="fix-200"
                ></multi-select>

                <!-- <v-select :items="itemsdrop" hide-details dense class="fix-200" filled></v-select> -->
              </div>
            </div>
            <div class="selected-student">
              <div class="label-data">
                Selected Students:
                {{selectedUsers.length}}
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
      <div class="data-table-section" ref="infoBox">
        <v-data-table
          :headers="onlineUser ? headers.filter((x) => x.value !== 'target_year') : headers"
          fixed-header
          :items="items"
          hide-default-header
          hide-default-footer
          class="elevation-2 cust-table"
        >
          <template v-slot:header="{ props: { headers } }">
            <TableHeader
              :headers="headers"
              :onHeaderAction="onHeaderAction"
              :orderBy="orderBy"
              :onSortChange="onSortChange"
            />
          </template>

          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="item in items" :key="item.id">
                <td class="check-50">
                  <div class="check-cust">
                    <v-checkbox
                      v-model=item.checked
                      
                      @change="addItems(item.id)"
                    ></v-checkbox>
                  </div>
                </td>
                <td class="lead-min-120">{{ item.roll_number || item.id }}</td>
                <td>{{ item.name }}</td>
                <td class="lead-300">{{ item.email }}</td>
                <td v-if="!onlineUser">{{ item && item.class_name ? (item.class_name).replaceAll('##', '-') : '' }}</td>
                <td>{{ item.center_name }}</td>
                <td>{{ item.batch_name }}</td>
                <td class="blank-80" @click="editStudentDialog(item)">
                  <v-tooltip left content-class="cust-tooltip">
                    <template v-slot:activator="{ on }">
                      <v-icon class="pencil-icon" v-on="on">mdi-pencil</v-icon>
                    </template>
                    <span>{{onlineUser ? 'Edit Center/Batch' : 'Edit Center/Target Year/Batch'}}</span>
                  </v-tooltip>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
        <AlertBox
          width="450px"
          :onClose="onClose"
          component="components/coordinator/users/ApprovedUsers/EditStudentBatchDetails"
          :status="status"
          :data="selctedUserForEdit"
        />
      </div>
    </v-card>
    <div class="footer-btn">
      <div class="pull-left">
        <v-btn
          :loading="loading"
          @click="requestApproveOrDisapproveUser(1)"
          class="right-btn cust-btn"
          color="primary"
          >Approve</v-btn
        >
        <v-btn
          :loading="loading"
          @click="requestApproveOrDisapproveUser(-1)"
          class="right-btn cust-btn"
          color="primary"
          >Disapprove</v-btn
        >
      </div>
      <div class="pull-right">
        <Pagination
          :currentPage="currentPage"
          :totalPage="totalPages"
          :onPageChange="onPageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
const user = JSON.parse(sessionStorage.getItem("user"));
import constants from "@/utils/constants.js";

export default {
  name: "UsersParents",
  props: ["updateRouteDetails"],
  data() {
    return {
      batches: [],
      centers: [],
      selectedCenterId: null,
      selectedBatch: null,
      loading: false,
      status: false,
      orderBy: {
        field: "name",
        order: "ASC",
      },
      items: [],
      selctedUserForEdit: null,
      currentPage: 1,
      pageSize: 10,
      totalPages: 1,
      gotAllTests: false,
      isLoadingFirstTime: true,
      onlineUser: false,
      selectedUsers: [],
    };
  },
  methods: {
    ...mapActions({
      getCentersByUser: "centerAndBatchStore/getCentersByUser",
      getBatches: "centerAndBatchStore/getBatches",
      getSelfSignedUpUsers: "userStore/getSelfSignedUpUsers",
      approveOrDisapproveUser: "userStore/approveOrDisapproveUser",
    }),
    requestApproveOrDisapproveUser(status) {
      if (status === 1) {
        let tmpArr = this.items.filter(
          (u) => u.checked && (!u.batch_name || u.batch_name.length === 0)
        );
        if (tmpArr && tmpArr.length) {
          return this.$toasted.error(`Please select user center and batch`, {
            icon: "check_circle",
          });
        }
      }

      // let user_ids = [];
      if (this.items && this.items.length) {
        // user_ids = this.items.filter((i) => i.checked).map((u) => u.id);
        if (!this.selectedUsers || this.selectedUsers.length < 1) {
          return this.$toasted.error(`Select atleast one user`);
        }
        let reqData = {
          role_id: this.roleIds.ST,
          status: status,
          user_ids: this.selectedUsers,
        };
        this.loading = true;
        this.approveOrDisapproveUser(reqData)
          .then((response) => {
            this.loading = false;
            this.requesGetSelfSignedUpUsers();
            this.$toasted.success(`Success\n${response.message}`, {
              icon: "check_circle",
            });
            this.selectedUsers = [];
          })
          .catch((err) => {
            this.loading = false;
          });
      }
    },
    onClose(data) {
      this.status = data.status;
      if (data.reload) {
        this.requesGetSelfSignedUpUsers();
      }
    },
    editStudentDialog(user) {
      this.selctedUserForEdit = user;
      this.status = true;
    },
    onCenterchange(centerIds) {
      this.selectedCenterId = centerIds;
      this.selectedBatch = [];
      this.items = [];
    },
    resetPage() {
      this.currentPage = 1;
      this.updateCurrentPageInSession(1);
    },
    onCenterSelect(centerIds) {
      if (centerIds && centerIds.length) {
        if (!this.isLoadingFirstTime) this.resetPage();
        this.updateRouteDetails({ type: "centerIds", data: { centerIds } });
        this.$root.showLoader = true;
        this.getBatches({ center_id: centerIds })
          .then((response) => {
            if (response && response.list && response.list.length) {
              if (this.selectedBatch) {
                let arr = [];
                this.selectedBatch.map((xx, i) => {
                  let isExist = false;
                  response.list.map((x) => {
                    if (!isExist) {
                      isExist = xx === x.id;
                    }
                  });
                  if (!isExist) {
                    arr.push(xx);
                  }
                });
                if (arr && arr.length) {
                  arr.map((xx) => {
                    this.selectedBatch.splice(
                      this.selectedBatch.indexOf(xx),
                      1
                    );
                  });
                }
              }
              let batchIds = [];
              this.batches = response.list.map((x) => {
                batchIds.push(x.id);
                let c = {};
                c.text = x.name;
                c.value = x.id;
                c.checked =
                  this.selectedBatch && this.selectedBatch.indexOf(x.id) !== -1;
                return c;
              });
              // this.$root.showLoader = false;
              // if (!this.gotAllTests) {
              //     this.gotAllTests = true;
              //     this.batches = this.batches.map(batch => {
              //         batch.checked = true;
              //         return batch;
              //     });
              //     this.selectedBatch = batchIds;
              // }
            } else {
              this.batches = [];
            }
          })
          .catch((err) => {
            this.$root.showLoader = false;
          });
      } else {
        this.batches = [];
      }
    },
    requestGetCenters() {
      this.$root.showLoader = true;
      this.getCentersByUser()
        .then((response) => {
          let centerIds = [];
          this.centers = response.map((x) => {
            centerIds.push(x.id);
            let c = {};
            c.text = x.name;
            c.value = x.id;
            c.checked = this.selectedCenterId.includes(x.id);
            return c;
          });
          // this.onCenterSelect(centerIds);
          // this.$root.showLoader = false;
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
    requesGetSelfSignedUpUsers() {
      // if(!this.selectedBatch || this.selectedBatch.length == 0) return;
      let reqData = {
        orderBy: this.orderBy,
        role_id: this.roleIds.ST,
        is_approved: 0,
        active: 1,
        pagination: { page: this.currentPage, pageSize: this.pageSize },
      };
      // console.log();
      if (
        this.selectedBatch &&
        this.selectedBatch.length > 0 &&
        this.batches.length != this.selectedBatch.length
      ) {
        reqData.batch_ids = this.selectedBatch;
      }
      if (
        this.selectedCenterId &&
        this.centers.length != this.selectedCenterId.length
      ) {
        reqData.center_ids = this.selectedCenterId;
      }
      this.$root.showLoader = true;
      this.getSelfSignedUpUsers(reqData)
        .then((response) => {
          this.isLoadedFirstTime = false;
          if (
            response.list.length == 0 &&
            this.currentPage != 1 &&
            !this.$route.query.resetPage
          ) {
            this.onPageChange(1);
            return;
          }
          this.items = response.list.map((u) => {
            u.checked = this.selectedUsers.includes(u.id) ? true : false;
            return u;
          });
          this.totalPages = response.pagination.pageCount;
          this.$root.showLoader = false;
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
    onHeaderAction(e) {
      if (e.header && e.header.type === "check") {
        this.items = this.items.map((u) => {
          u.checked = e.data.checked;
          this.selectedUsers.indexOf(u.id) === -1 && e.header.checked ? this.selectedUsers.push(u.id) : this.selectedUsers.splice(this.selectedUsers.indexOf(u.id), 1);
          return u;
        });
      }
    },
    onSortChange() {
      this.requesGetSelfSignedUpUsers();
    },
    onPageChange(e) {
      this.currentPage = e;
      this.requesGetSelfSignedUpUsers();
    },
    onBatchSelect(selectedBatch) {
      this.selectedBatch = selectedBatch;
      if (!this.isLoadingFirstTime) this.resetPage();
      this.items = [];
    },
    defaultData() {
      let routeName = this.$route.name;
      let crd = this.getCurrentRouteDetails(routeName);
      if (crd) {
        this.currentPage = crd.tabDetails[crd.selectedTab].page;
        this.orderBy = crd.tabDetails[crd.selectedTab].orderBy;
        this.selectedCenterId = crd.tabDetails[crd.selectedTab].centerIds; // load center ids from session
        this.selectedBatch = crd.tabDetails[crd.selectedTab].batchIds; // load batches in session
      }
      this.requestGetCenters();
      if (!crd && !crd.tabDetails[crd.selectedTab].centerIds) {
        this.requesGetSelfSignedUpUsers();
      }
    },
    addItems(id) {
      let index = this.selectedUsers.indexOf(id);
      if (index > -1) {
        this.selectedUsers.splice(index, 1);
      } else {
        this.selectedUsers.push(id);
      }
    },
  },
  mounted() {
    this.onlineUser = this.user.institute === constants.ONLINE_INSTITUTE_ID ? true : false        
    this.defaultData();
  },
  computed: {
    ...mapState("userStore", ["user"]),
    headers() {
      return [
        {
          text: "",
          value: "check",
          type: "check",
          class: "check-50",
          checked: this.isAllUserSelected,
        },
        { text: "Student Id / \nRoll No.", value: "roll_number",class: "lead-min-120" },
        { text: "Name", value: "name" },
        { text: "Email Id", value: "email", class:"lead-300" },
        { text: "Target Year", value: "class_name" },
        { text: "Center", value: "center_name" },
        { text: "Batch", value: "batch_name" },
        { text: "", value: "", type: "blank", class: "blank-80" },
      ];
    },
    isAllUserSelected() {
      if (this.items && this.items.length) {
        let tmpArry = this.items.filter((x) => x.checked);
        if (tmpArry) {
          return tmpArry.length === this.items.length;
        }
      }
      return false;
    },
  },
  watch: {
    selectedCenterId(val) {
      if (val) {
        this.onCenterSelect(val);
        // this.requesGetSelfSignedUpUsers();
      }
    },
    selectedBatch(val) {
      this.updateRouteDetails({ type: "batchIds", data: { batchIds: val } });
      this.requesGetSelfSignedUpUsers();
    },
  },
};
</script>
